import { useState, useEffect } from "react";

export default function ImageSlider({ images, interval = 3000 }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [autoSlide, setAutoSlide] = useState(null);

    useEffect(() => {
        startAutoSlide();
        return () => stopAutoSlide();
    }, [currentIndex, interval]);

    const startAutoSlide = () => {
        stopAutoSlide(); // Clear previous interval before starting a new one
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, interval);
        setAutoSlide(timer);
    };

    const stopAutoSlide = () => {
        if (autoSlide) clearInterval(autoSlide);
    };

    const handleNext = () => {
        stopAutoSlide();
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        startAutoSlide();
    };

    const handlePrev = () => {
        stopAutoSlide();
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
        startAutoSlide();
    };

    if (!images || images.length === 0) {
        return <p className="text-center text-gray-400">No images available</p>;
    }

    return (
        <div className="relative w-full max-w-lg mx-auto">
            <img
                src={images[currentIndex]}
                alt={`Slide ${currentIndex + 1}`}
                className="w-full h-auto rounded-lg shadow-lg transition-opacity duration-500 mx-auto"
            />

            {/* Previous Button */}
            <button
                onClick={handlePrev}
                className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-gray-800 text-white p-3 rounded-full shadow-md hover:bg-gray-700 hover:scale-110 transition-all"
            >
                ◀
            </button>

            {/* Next Button */}
            <button
                onClick={handleNext}
                className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-gray-800 text-white p-3 rounded-full shadow-md hover:bg-gray-700 hover:scale-110 transition-all"
            >
                ▶
            </button>
        </div>
    );
}
